import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CssBaseline } from '@mui/material';
import { App } from '@app/ui/pages/root-page';
import { createRoot } from 'react-dom/client';
import { REACT_QUERY_CONFIG } from './config';
import './global.css';

const queryClient = new QueryClient(REACT_QUERY_CONFIG);

const RootApp = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <CssBaseline />
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<RootApp /> as any);
}

export default RootApp;
